function isEmpty(obj) {
  if (obj) {
    if (Object.keys(obj).length === 0) {
      return true;
    } else {
      return false;
    }
  }
  return true;
}

function isOfType(v) {
  const typeCheck = Object.prototype.toString;
  return typeCheck.call(v);
}

export function GenerateQueryParameterString(
  obj,
  isStartOfQueryString = true,
  isEndOfQueryString = true
) {
  if (isEmpty(obj)) {
    return "";
  }
  const arr = Object.keys(obj)
    .filter((item) => {
      if (obj[item] === null || obj[item] === undefined) {
        return "";
      }
      const keyStr = obj[item].toString();
      return keyStr.trim() !== "" && keyStr;
    })
    .map((item) => {
      const keyStr = item.toString();
      if (isOfType(obj[item]) === "[object String]") {
        const checkHowManyCommaSepartedItems = obj[item].split(",");
        if (checkHowManyCommaSepartedItems.length > 1) {
          return encodeURIComponent(keyStr) + "__in=" + encodeURIComponent(obj[item]);
        }
        return keyStr + "=" + obj[item];
      }
      if (isOfType(obj[item]) === "[object Array]") {
        if (obj[item].length > 1) {
          return encodeURIComponent(keyStr) + "__in=" + encodeURIComponent(obj[item].join(","));
        }
      }
      return encodeURIComponent(keyStr) + "=" + encodeURIComponent(obj[item]);
    });

  const queryStartSymbol = isStartOfQueryString === true ? "?" : "&";
  const queryEndSymbol = isEndOfQueryString === true ? "" : "&";

  return arr.length > 0 ? queryStartSymbol + arr.join("&") + queryEndSymbol : "";
}
